/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Error_UnlockInputs */



/**
* | output |
* | --- |
* | "Failed to unlock tournament" |
*
* @param {Offline_Error_UnlockInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_error_unlock = /** @type {((inputs?: Offline_Error_UnlockInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Error_UnlockInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec du déverrouillage du tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al desbloquear el torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao desbloquear o torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile sbloccare il torneo")
	return /** @type {LocalizedString} */ ("Failed to unlock tournament")
});